module.exports = __webpack_public_path__ + "static/media/img_dianshang_3@2x.8df61d08.png";